import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { MainModal } from "../../../components/modal/MainModal";
import { acceptNotification } from "../redux/sagas/userMenu/userMenu";

export const Notification = () => {
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const { notification: { message, id } = {} } = useSelector((state) => state.userMenu);

  const onSave = () => {
    dispatch(acceptNotification(id));
  };

  const toggleModal = () => {
    setIsOpen(typeof id == "number");
  };

  useEffect(() => {
    toggleModal();
  }, [id]);

  return (
    <MainModal
      isOpen={isOpen}
      parentSelector="body"
      containerClassName="preview popup__notification"
      width="1350px"
      height="auto"
      primaryButtonText="I acknowledge this message"
      primaryBtnHandler={onSave}
      onClose={() => setIsOpen(false)}
      swapFooter
      customStyles={{ margin: "auto", left: 0, right: 0 }}
    >
      <div dangerouslySetInnerHTML={{ __html: message }} />
    </MainModal>
  );
};
